import { FC } from "react";
import { useSelector } from "react-redux";

import { RootState } from "store";
import { selectCurrentPairWinPercent } from "store/slices/tradingSlice";
import { formatPayoutPercent } from "shared/utils";

import styles from "./CurrentPayout.module.css";

/** Payout of the currently selected trading pair. */
export const CurrentPayout: FC = () => {
  const selectedPair = useSelector(
    (state: RootState) => state.trading.selectedPair,
  );
  const winPercent = useSelector((state: RootState) =>
    selectCurrentPairWinPercent(state.trading),
  );

  if (!selectedPair) return null;

  return (
    <button className={`button ${styles.payout}`}>
      <span className={styles.label}>Payout:</span>
      <span className={styles.value}>{formatPayoutPercent(winPercent)}%</span>
    </button>
  );
};
